module.exports = __webpack_public_path__ + "img/2.086dbf83.png";